// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-scrollbar{scrollbar-width:thin;scrollbar-color:#ff8c2f var(--color-alpha)}.custom-scrollbar::-webkit-scrollbar{width:10px}.custom-scrollbar::-webkit-scrollbar-track{background:var(--color-alpha);border:0}.custom-scrollbar::-webkit-scrollbar-thumb{background-color:#ff8c2f;border-radius:4px;border:0}", ""]);
// Exports
module.exports = exports;
